<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
          </div>
          <div class="col-sm-5 text-right">
          </div>
        </div>
      </div>
      <div class="p-15">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" :current-page="currentPage">
          <template slot="date" slot-scope="data">
            {{parseDate(data.item.date)}}
          </template>
          <template slot="pha_status" slot-scope="data">
            <b-badge v-if="data.item.pt_planner_activity_id == 2" variant="success">PHA Appointment</b-badge>
            <b-badge v-else variant="danger">-</b-badge>
          </template>
          <template slot="show_status" slot-scope="data">
            <b-badge v-if="data.item.show_status == 1" variant="success">Yes</b-badge>
            <b-badge v-else variant="danger">No</b-badge>
          </template>
          <template slot="actions" slot-scope="data">
            <b-button size="sm" @click="openPage('/memberData/detail?id=' + data.item.member.id + '&member_pha=true')" class="btn-table green mr-1">
              <i class="far fa-eye"></i> Detail
            </b-button>
            <b-button v-if="getRoleId != '33'" size="sm" @click="openPage('/memberPha/reschedule?id=' + data.item.id + '&member_id=' + data.item.member.id + '&member_pha=true')" class="btn-table primary mr-1">
              <i class="far fa-calendar-alt"></i> Reschedule
            </b-button>
          </template>
        </b-table>
        <app-pagination
          class="pagination-custom mt-20"
          :current-page="currentPage"
          :total-pages="totalPage"
          @page-changed="pageOneChanged"
          prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'
import { get } from 'jquery'

export default {
  name: 'memberPha',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'member_name',
          label: 'Member Name',
          formatter: (value, key, item) => {
            return (item.member ? item.member.first_name + ' ' + item.member.last_name : '-')
          },
          sortable: false
        },
        {
          key: 'branch.name',
          label: 'Branch',
          sortable: false
        },
        {
          key: 'phone',
          label: 'Phone Number',
          formatter: (value, key, item) => {
            return (item.member ? item.member.phone_number : '-')
          },
          sortable: false
        },
        {
          key: 'membership_last_buy_name',
          label: 'Membership Type',
          formatter: (value, key, item) => {
            return (item.member ? item.member.membership_last_buy_name : '-')
          },
          sortable: false
        },
        {
          key: 'date',
          label: 'Schedule Date',
          sortable: false
        },
        {
          key: 'time',
          label: 'Time',
          formatter: (value, key, item) => {
            return item.pt_planner_time ? (item.pt_planner_time.time_start).slice(0,-3) + ' - ' + (item.pt_planner_time.time_end).slice(0,-3) : ''
          },
          sortable: false
        },
        {
          key: 'pt_planner_activity.name',
          class: 'text-center',
          label: 'PT Planner Activity',
          sortable: false
        }
      ],
      branch_id: null,
      dataBranch: [],
      items: [],
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role
    }
  },
  methods: {
    changeBranch(event) {
      console.log(event)
      this.fetchData()
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    fetchData() {
      axios.get('crm/v1/pt_planner/memberPha/reschedule_history?personal_trainer_id=' + Auth.Session.get().paradigm_id + '&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&branch_id=' + this.branch_id)
      .then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      // branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
